<!--
  name : 이예닮
  desc : 계약 정보 설정
  date : 2021-07-19
-->
<template>
<v-row no-gutters>
  <v-container id="contr" class="con_mpw">
     <v-row no-gutters class="row_mb-40">
      <div class="dot_tt">워터마크 설정</div>
      <v-col cols="12">
        <v-row no-gutters class="contr_waterM_con">
          <v-col cols="12">
            <v-row no-gutters class="feepay_round_box align-center">
              <!--list-->
              <v-col cols="12">
                <!-- class="primary v-slide-item--active" -->
                <v-slide-group v-model="model" class="savemark_list" mandatory show-arrows>
                  <v-slide-item v-for="(watermark, index) in watermarkList" :key="index">
                    <v-card>
                      <v-checkbox class="doc_type_chk"
                        v-model="wmCheckedList"
                        :value="index"
                        @click="getWaterMarkInfo(index)"
                        hide-details
                      ></v-checkbox>
                      <v-row no-gutters class="fill-height mt-0" align="center" justify="center">
                        <v-scale-transition>
                          <!-- <span class="icon chk"></span> -->
                        </v-scale-transition>
                        <v-img :src="watermark.url"></v-img>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-col>

              <!-- 워터마크 없을 때 -->
              <v-col cols="12" v-if="watermarkList.length == 0">
                <div class="list_no_txt">
                  등록된 워터마크가 없습니다.
                </div>
              </v-col>

              <v-col cols="12">
                <v-row no-gutters class="waterM_btn_con">
                  <v-col>
                    <v-btn class="btn18_C05" v-if="watermarkList.length !== 0" outlined @click="deleteWaterMark">선택 삭제</v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="10">
                    <v-row no-gutters class="align-start waterM_btnC_justify-mbR-smL">
                      <div class="sm-pt-10"><v-btn class="btn18_00" outlined @click="signVisible = true">전자서명 등록</v-btn></div>
                      <div class="sm-pt-10">
                        <div class="d-inline-block" style="vertical-align:top;">
                          <v-file-input class="inputH48_01" outlined accept="image/*"
                          messages="5MB 이하의 이미지 파일을 업로드 할 수 있습니다."
                          label="워터마크 직접 업로드"
                          ref="watermarkFile"
                          v-model="watermarkFile"
                          >
                          </v-file-input>
                        </div>
                        <div class="d-inline-block" style="vertical-align:top;" v-if="watermarkFile != ''">
                          <v-btn class="btn17_C01" @click="watermarkFileUpload">등록</v-btn>
                        </div>
                      </div>
                    </v-row>

                  </v-col>
                </v-row>
              </v-col>

            </v-row>
          </v-col>

        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters class="row_mb-40">
      <div class="dot_tt">부가정보 등록</div>
      <div class="txtst_info_gray">수신자로 지정된 계약 작성 시 사용 설정하신 부가 정보가 보여집니다.</div>
      <v-col cols="12" class="mt-5">
        <v-row no-gutters class="coNlistCon_sideInfo adtInf_scroll">

          <!-- list -->
          <v-col v-for="(info, i) in infos" :key="i" cols="12" class="coNlist_receiverCpn">
            <v-card class="carD_sideInfo">
              <ul class="pattern_ulTxtBox">
                <li>
                  <v-text-field ref="activeRules" class="inputH48_03"
                    label="제목"
                    v-model="info.key"
                    :rules="active_rules"
                    required
                  >
                  </v-text-field>
                </li>
                <li class="radio_posiA justify-end">
                  <v-radio-group class="radioCon" row v-model="info.active">
                    <v-radio label="사용" value="1"></v-radio>
                    <v-radio label="미사용" value="2"></v-radio>
                  </v-radio-group>
                </li>
              </ul>
              <div class="btnCon_carD_receiv">
                <v-btn icon class="btnO_C04 delete" @click="deleteSubInfo (i)"><span class="icon">삭제</span></v-btn>
              </div>
            </v-card>
          </v-col>

          <!-- 부가정보 없을 때 -->
          <div v-if="infos.length == 0" class="list_no_txt">
            등록된 부가정보가 없습니다.
          </div>

        </v-row>
        <v-card-actions>
          <v-btn text class="btn17_C01" v-if="this.infos.length < 5" @click="add"><span class="icon"></span>부가정보 추가</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined class="btn17_00" @click="save"><span class="icon save"></span>저장</v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-container>
  <!--signVisible-->

  <!--Popup-->
  <v-dialog width="440px" v-model="signVisible" @keydown.esc="signVisible = false">
    <v-card id="popStyle03">
      <!--title-->
      <v-card-title class="title">
        전자서명 등록
      <v-btn fab class="popBtnClose" @click="close()"></v-btn>
      </v-card-title>
      <v-card-text class='scrollYst savemark_scrollCon'>
          <insert-signature ref="signature" :visibleCheckBox='true'></insert-signature>
      </v-card-text>
      <!--button-->
      <v-card-actions class="justify-center">
        <v-btn text @click="registSignature()">확인</v-btn>
        <v-btn text @click="signBeforeClose()">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <s-loading ref="loading"></s-loading>
  <s-confirm ref="confirm"></s-confirm>
  </v-row>
</template>
<script>
import insertSignature from '@/components/signature'
import { setMetaStr, getSettingContract } from '@/api/setting/contractAdmin'
import { getIsAdmin } from '@/api/user'
import { registSignature, getWaterMarkList, deleteWaterMark, uploadWaterMark } from '@/api/contract/insertWatermark'

var URL = {
  thumbnail: process.env.VUE_APP_URL_THUMBNAIL,
  watermark: process.env.VUE_APP_URL_WATERMARK
}

export default {
  name: 'scontract',
  components: {
    insertSignature
  },
  filters: {
  },
  data () {
    return {
      activeName: '',
      // Popup
      signVisible: false, // 전자서명 등록

      // 워터마크
      model: null,
      watermarkFile: [],
      watermarkList: [],  // list
      wmCheckedList: [],  // Check List

      // 부가정보
      infos: [],
      params: {
        activeName: null,
        data: null
      },

      //  부가정보 문자열 조건
      active_rules: [
        v => !!v || '필수값 입니다.',
        v => !/[0-9]/.test(v.charAt(0)) || '첫문자 숫자 불가',  // v.charAt(0) null 값 때문에 consol에서 에러
        v => !/[~!@#$%^&*()_+|<>?:{}]/.test(v) || '특수문자 불가',
        v => !/[\s]/g.test(v) || '공백 불가'
      ],
    }
  },

  created () {
    if (this.activeName === 'company') {
      this.getIsAdmin()
    }
  },
  mounted () {
    if(this.$store.state.user.orgaddr) {
      this.activeName = 'company'
    } else {
      this.activeName = 'personal'
    }
    this.getWaterMarkList()
    this.getSettingContract()
  },
  methods: {
    getIsAdmin () {
      getIsAdmin().then(response => {
        this.isAdmin = response.rdata.isAdm
      }).catch(e => {
      })
    },

    // 전자서명 추가
    registSignature () {
      var data = this.$refs.signature.save()
      if (data.data) {
        this.$refs.loading.start('입력 정보 확인 중')
        registSignature({ isWatermark: true, activeName: this.activeName, signBase64: data.data }).then(response => {
          this.$refs.loading.end()
          this.$refs.signature.clear()
          this.signVisible = false
          this.$refs.confirm.open('alert', '전자서명 추가', '워터마크가 추가되었습니다.')
          this.getWaterMarkList()
        }).catch(e => {
          console.error(e)
        })
      }
    },

    signBeforeClose () {
      this.$refs.confirm.open('confirm', '전자서명', '현재 창을 닫으시면 작성한 전자서명이 지워집니다. 그래도 닫으시겠습니까?').then(() => {
        this.signVisible = false
      })
    },

    // 워터마크 체크 유무 함수
    getWaterMarkInfo (index) {
      this.watermarkList[index].isChecked = !this.watermarkList[index].isChecked
    },

    // 워터마크 조회
    getWaterMarkList () {
      this.$refs.loading.start('입력 정보 확인 중')
      getWaterMarkList(JSON.stringify({ activeName: this.activeName })).then(response => {
        this.$refs.loading.end()
        this.watermarkList = []
        for (var k in response.rdata.watermarks) {
          this.watermarkList.push({
            id: response.rdata.watermarks[k].watermarkSequence,
            url: URL.thumbnail + response.rdata.watermarks[k].watermarkSequence,
            originUrl: URL.watermark + response.rdata.watermarks[k].watermarkSequence
          })
        }
      }).catch(e => {
      })
      this.loading = false
    },

    // 워터마크 삭제
    deleteWaterMark () {
      this.wmCheckedList = []
      for (var num in this.watermarkList) {
        if (this.watermarkList[num].isChecked) {
          this.wmCheckedList.push(this.watermarkList[num])
        }
      }
      if (this.wmCheckedList.length !== 0) {
        this.$refs.confirm.open('confirm', '워터마크 삭제', '선택한 ' + this.wmCheckedList.length + '개 워터마크를 삭제하시겠습니까?').then(() => {
          this.$refs.loading.start('입력 정보 확인 중')
          deleteWaterMark(JSON.stringify(this.wmCheckedList)).then(response => {
            this.$refs.loading.end()
            if (response.rcode === 20000) {
              this.$refs.confirm.open('alert', '워터마크 삭제', '워터마크 삭제에 성공했습니다.')
              this.getWaterMarkList ()
            }
          })
        })
        for (var i in this.watermarkList) {
          this.watermarkList[i].isChecked = false
        }
      } else {
        this.$refs.confirm.open('alert', '워터마크 삭제', '삭제할 워터마크를 선택해주세요.')
      }
    },

    // 파일 size 검사
    watermarkFileCheck () {
      if(this.watermarkFile.size > 5000000) {
        this.$refs.confirm.open('alert', '워터마크', '5MB 이하의 이미지만 등록 가능합니다.').then(() => {
          this.watermarkFile=[]
        })
      }
    },

    // watermarkFileUpload
    watermarkFileUpload () {
      const data = new FormData()
      data.append('file', this.watermarkFile)
      data.append('activeName', this.activeName)

      this.$refs.loading.start('입력 정보 확인 중')
      uploadWaterMark(data).then(response => {
        if (response.rcode === 20000) {
          this.$refs.loading.end()
          this.$refs.confirm.open('alert', '워터마크가 추가', '워터마크가 추가되었습니다.')
          this.watermarkFile=[]
          this.getWaterMarkList ()
        }
      })
    },

    // 부가정보 조회
    getSettingContract () {
      this.infos = []
      getSettingContract(JSON.stringify({ activeName: this.activeName })).then(response => {
        var metaStr = response.rdata.settingData.metaString
        if (!metaStr) {
          this.infos = []
        } else {
          this.infos = JSON.parse(metaStr)
        }
      })
    },
    // 부가정보 추가
    add () {
      this.infos.push({ key: this.t, active: true })
    },
    // 부가정보 저장
    save () {
      var checkRules = true
      for (var i in this.infos) {
        if (!this.$refs.activeRules[i].validate()) {
          checkRules = false
        }
      }
      if (checkRules) {
        this.params.activeName = this.activeName
        this.params.data = this.infos

        this.$refs.loading.start('입력 정보 확인 중')
        setMetaStr(this.params).then(response => {
          this.$refs.loading.end()
          if (response.rcode === 20000) {
            this.$refs.confirm.open('alert', '부가정보 저장', '부가 정보 설정을 완료했습니다.')
            this.getSettingContract()
          } else {
            this.$refs.confirm.open('alert', '부가정보 저장', '부가 정보 설정을 실패했습니다.')
          }
        })
      } else {
        this.$refs.confirm.open('alert', '부가정보 저장', '부가 정보 형식을 확인해주세요.')
      }
    },
    // 부가정보 삭제
    deleteSubInfo (index) {
      if (this.infos.length === 1) {
          this.$refs.confirm.open('confirm', '부가정보 삭제', '마지막 부가정보를 삭제하시면 부가정보가 없는 상태로 저장됩니다.\n삭제하시겠습니까?').then(() => {
          this.$refs.confirm.open('alert', '부가정보 저장', '부가 정보 설정을 완료했습니다.')
          this.infos.splice(index, 1)
          this.save()
        })
      } else if (this.infos.length > 1) {
        this.$refs.confirm.open('confirm', '부가정보 삭제', '부가정보를 삭제하시겠습니까?').then(() => {
          this.infos.splice(index, 1)
        })
      }
    },
  }
}
</script>

<style>
.waterM_round_box {
    position: relative;
    margin: 20px 0;
    padding: 8px 14px;
    border: 1px solid #cccccc;
    border-radius: 8px;
}
.waterM_btnC_justify-mbR-smL{
  justify-content:flex-end;
}
.adtInf_scroll {
    padding: 12px 0;
    max-height: 30vh;
    overflow-y: auto;
    border-top: 1px solid #d7d8da;
    border-bottom: 1px solid #d7d8da;
}
.list_no_txt{
  padding: 20px 0;
  width: 100%;
  font-size: .8rem;
  color: #a4a5a9;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}
@media (max-width:959px) {
  .waterM_btnC_justify-mbR-smL{
    justify-content:flex-start;
  }
  .sm-pt-10{
    padding-top:10px !important;
  }
  .adtInf_scroll{
    max-height: 100%;
  }
}
</style>
